import {Component, Input, OnInit} from '@angular/core';

import {environment} from '../../../../environments/environment';
import {ApiService} from '../../../custom-services/ApiService';
import {CommonUtilService} from '../../../service/utils/common-utils';

@Component({
    standalone: false,
  selector: 'app-csr-info-return',
  templateUrl: './csr-info-return.component.html',
  styleUrls: ['./csr-info-return.component.css']
})
export class CsrInfoReturnComponent implements OnInit {
  @Input() printActive: boolean;
  @Input() returnData: any;
  @Input() isSinglePageReturn: boolean;

  bankNameOptions = [];

  donationCategoryList = [
    {value: 'FUND_ESTABLISHED_UNDER_PMEAT', label: 'Fund established under the PMEAT Act, 2012'},
    {value: 'GIRLS_SCHOOL_OR_COLLEGE', label: 'Girls’ school/college'},
    {value: 'TECHNICAL_AND_VOCATIONAL_TRAINING_INSTITUTE', label: 'Technical and vocational training institute'},
    {value: 'AS_SUNNAH_FOUNDATION', label: 'As-Sunnah Foundation'},
    {value: 'NATIONAL_LEVEL_INSTITUTE', label: 'Any national-level institute engaged in R&D'}
  ];

  constructor(private apiService: ApiService) {
  }

  ngOnInit(): void {
    this.getCSRData();
  }

  getCSRData() {
    if (this.returnData?.headSummery?.csrSummary?.csrList) {
      this.returnData.headSummery.csrSummary.csrList =
        this.returnData.headSummery.csrSummary.csrList.map(record => ({
          ...record,
          donationCategoryLabel: this.getDonationCategoryLabel(record.donationCategory)
        }));
      this.loadBankList();
    }
  }

  loadBankList() {
    this.apiService.get(environment.taxpayer_base_url + '/filingservice/v3/api/banks').subscribe((res: any) => {
      this.bankNameOptions = res.interestBanks.filter(bank => bank.type === 'SCHEDULED_BANK' || bank.type === 'NON_SCHEDULED_BANK')
        .map(bank => ({...bank, disabled: false}));
      this.bankNameOptions = CommonUtilService.sortBankList(this.bankNameOptions);
      this.applyBankNames();
    });
  }

  applyBankNames() {
    const csrList = this.returnData?.headSummery?.csrSummary?.csrList;
    if (!csrList) {
      return;
    }
    this.returnData.headSummery.csrSummary.csrList = csrList.map(record => ({
      ...record,
      receiverBankName: this.getBankName(record.receiverBankId),
      assesseeBankName: this.getBankName(record.assesseeBankId)
    }));
  }

  getBankName(bankId: any): string {
    if (bankId === null || bankId === undefined || bankId === '') {
      return '';
    }
    const found = this.bankNameOptions.find(bank => bank.id == bankId);
    return found ? found.bankName : '';
  }

  getDonationCategoryLabel(value: string): string {
    const found = this.donationCategoryList.find(item => item.value === value);
    return found ? found.label : value;
  }
}
